<template>
  <div
    class="p-3 has-border-light has-border-radius is-flex is-justify-content-space-between is-align-items-center is-full-width"
  >
    <span class="is-flex is-flex-direction-column">
      <span class="has-text-weight-semibold is-relative">
        {{ title }}
      </span>
      <span class="is-size-7 has-text-weight-semibold has-text-grey is-uppercase"></span>
    </span>
    <div>
      <ButtonView
        class="button is-outlined m-r-10"
        type="is-primary"
        @click="onShare"
        :data-e2e="DiagnosticToolCypressAttribute.buttons.SHARE"
      >
        {{ $t('asset.share') }}
      </ButtonView>
      <ButtonView
        icon-pack="cls"
        icon-left="cls cls-opportunities"
        type="is-primary"
        @click="showForm"
        :data-e2e="DiagnosticToolCypressAttribute.buttons.LAUNCH"
      >
        {{ $t('tools.launch') }}
      </ButtonView>
    </div>
  </div>
</template>

<script>
import { DiagnosticToolCypressAttribute } from '@/modules/typeform/constants/DiagnosticToolCypressAttribute';
import { DiagnosticToolShareClickedEventTracking } from '@/modules/typeform/models/segmentevents/DiagnosticToolShareClickedEventTracking';
import ModalService from '@/modules/core/ui/services/ModalService';
import DiagnosticToolShareFormModal from '@/modules/typeform/components/stateful/DiagnosticToolShareFormModal.vue';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'DiagnosticToolLaunchCard',
  emits: ['show-form'],
  components: { ButtonView },
  props: {
    title: {
      type: String,
      required: true
    },
    formId: {
      type: String,
      required: true
    }
  },
  static: {
    DiagnosticToolCypressAttribute
  },
  methods: {
    showForm() {
      this.$emit('show-form');
    },
    onShare() {
      ModalService.show({
        parent: this,
        component: DiagnosticToolShareFormModal,
        width: 1500,
        props: {
          formId: this.formId
        }
      });
      DiagnosticToolShareClickedEventTracking.dispatch(this.formId);
    }
  }
};
</script>
